import { render, staticRenderFns } from "./DeleteShareholderModal.vue?vue&type=template&id=82cba180&scoped=true"
import script from "./DeleteShareholderModal.vue?vue&type=script&lang=js"
export * from "./DeleteShareholderModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteShareholderModal.vue?vue&type=style&index=0&id=82cba180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cba180",
  null
  
)

export default component.exports